const SERVER = import.meta.env.VITE_API_URL;
import axios from "../../configs/axios.config";

const getDriversEarning = async (page, limit) => {
  // TODO: Replace with actual API call when endpoint is ready
  // Returning static mock data for now
  return {
    success: true,
    data: [
      {
        driver: "John Doe",
        driverid: "DRV001",
        date: new Date("2026-01-02"),
        tripId: "TRP12345",
        distance: 15.5,
        fare: 450,
        base: 350,
        da: 100,
        total: 450,
      },
      {
        driver: "Jane Smith",
        driverid: "DRV002",
        date: new Date("2026-01-02"),
        tripId: "TRP12346",
        distance: 22.3,
        fare: 680,
        base: 520,
        da: 160,
        total: 680,
      },
      {
        driver: "Mike Johnson",
        driverid: "DRV003",
        date: new Date("2026-01-02"),
        tripId: "TRP12347",
        distance: 10.2,
        fare: 320,
        base: 250,
        da: 70,
        total: 320,
      },
      {
        driver: "Sarah Williams",
        driverid: "DRV004",
        date: new Date("2026-01-01"),
        tripId: "TRP12348",
        distance: 18.7,
        fare: 550,
        base: 430,
        da: 120,
        total: 550,
      },
      {
        driver: "David Brown",
        driverid: "DRV005",
        date: new Date("2026-01-01"),
        tripId: "TRP12349",
        distance: 25.0,
        fare: 750,
        base: 580,
        da: 170,
        total: 750,
      },
    ],
    total: 5,
    page: page || 1,
    limit: limit || 10,
  };

  /* Original API call - uncomment when endpoint is ready
    try {
        let token = localStorage.getItem("prima_session");

        if (!token) {
            throw new Error("Token not found");
        }
        let response = await axios.get(`${SERVER}/api/accounts/driver/earnings?page=${page}&limit=${limit}`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            withCredentials: true,
        });

        if (response.status === 401 || response.status === 403) {
            throw new Error("Unauthorized user");
        }
      
        return response.data;
    } catch (error) {
        console.error("Error fetching drivers earning:", error.response?.data?.message || error.message);
        throw new Error(error.response?.data?.message || "Failed to fetch drivers earning");
    }
    */
};

const getDriversPayout = async (page, limit) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.get(
      `${SERVER}/api/accounts/payout?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching drivers payout:",
      error.response?.data?.message || error.message,
    );
    throw new Error(
      error.response?.data?.message || "Failed to fetch drivers payout",
    );
  }
};

const getDriversBonus = async (page, limit) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.get(
      `${SERVER}/api/accounts/bonus?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching drivers bonus:",
      error.response?.data?.message || error.message,
    );
    throw new Error(
      error.response?.data?.message || "Failed to fetch drivers bonus",
    );
  }
};

const getDriversDeduction = async (page, limit) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.get(
      `${SERVER}/api/accounts/deduction?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching drivers deduction:",
      error.response?.data?.message || error.message,
    );
    throw new Error(
      error.response?.data?.message || "Failed to fetch drivers deduction",
    );
  }
};

const getDriversFailed = async (page, limit) => {
  try {
    let token = localStorage.getItem("prima_session");

    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.get(
      `${SERVER}/api/accounts/payout/failed?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching drivers failed:",
      error.response?.data?.message || error.message,
    );
    throw new Error(
      error.response?.data?.message || "Failed to fetch drivers failed",
    );
  }
};

const getDriverPayDetails = async (driverId) => {
  try {
    let token = localStorage.getItem("prima_session");
    if (!token) {
      throw new Error("Token not found");
    }
    let response = await axios.get(
      `${SERVER}/api/accounts/driver/${driverId}/ledger`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );
    if (response.status === 401 || response.status === 403) {
      throw new Error("Unauthorized user");
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching drivers pay details:",
      error.response?.data?.message || error.message,
    );
    throw new Error(
      error.response?.data?.message || "Failed to fetch drivers pay details",
    );
  }
};

export {
  getDriversEarning,
  getDriversPayout,
  getDriversBonus,
  getDriversDeduction,
  getDriversFailed,
  getDriverPayDetails,
};
